import api from "../api";

const endpointBase = "/api/subscriptions";

class SubscriptionService {
  async subscribeUserToResource(userId, resourceId) {
    return api.post(`${endpointBase}/${userId}/${resourceId}`);
  }

  async unsubscribeUserFromResource(userId, resourceId) {
    return api.delete(`${endpointBase}/${userId}/${resourceId}`);
  }

  async getResourcesByUser(userId) {
    return api.get(`${endpointBase}/resourcesByUser/${userId}`);
  }

  async getUsersByResource(resourceId) {
    return api.get(`${endpointBase}/usersByResource/${resourceId}`);
  }
}

export default new SubscriptionService();
